import { observer } from 'mobx-react-lite'

import { DashboardStatTile, StatGrid } from '@/Ship/Components/Dashboard/DashboardStatTile'
import { Panel, useChartColors } from '@/Ship/Components/Dashboard/Overview/shared'
import { Hint } from '@/Ship/Components/Hint'
import { dashboardManager } from '@/Ship/Stores/DashboardManager'

/** Підписи — дослівно з легасі (`translation.json:614-616`). */
export const APPLICATIONS_TILES = {
    new: 'Нові заявки',
    offersToday: 'Пропозиції по заявкам',
    confirmedToday: 'Підтверджені сьогодні',
} as const

/**
 * «Заявки» (`SPEC-027` §2.4, §3.5): «Нові заявки» синім — пресетом палітри
 * теми, а не `colorPrimary`/`colorInfo`: у бренді Астерікса вони червоні й
 * читалися б як тривога. «Нові заявки» й
 * «Пропозиції по заявкам» (створені сьогодні) — по всій компанії й від
 * обраного співробітника не залежать (Q3.10); «Підтверджені сьогодні» — свої
 * або обраного. Бачать усі.
 */
/** Пояснення до блоку «Заявки сьогодні» — над рядом блоків, а не всередині сітки. */
export const TransportApplicationsHint = () => (
    <Hint id="dashboard.transport.applications">
        «Нові заявки» й «Пропозиції по заявкам» — по всій компанії, «Підтверджені сьогодні» — ваші заявки як менеджера
        клієнта чи логіста; адміністратор без фільтра бачить тут усю компанію.
    </Hint>
)

export const TransportApplicationsTiles = observer(() => {
    const chart = useChartColors()
    const { transport, isTransportLoading } = dashboardManager
    const applications = transport?.applications

    return (
        <Panel block="transport-applications" title="Заявки сьогодні" subtitle="Нові й пропозиції — по компанії">
            <StatGrid columns={3}>
                <DashboardStatTile
                    tile="applications.new"
                    title={APPLICATIONS_TILES.new}
                    value={applications?.new}
                    loading={isTransportLoading}
                    color={chart.primary}
                />
                <DashboardStatTile
                    tile="applications.offersToday"
                    title={APPLICATIONS_TILES.offersToday}
                    value={applications?.offersToday}
                    loading={isTransportLoading}
                />
                <DashboardStatTile
                    tile="applications.confirmedToday"
                    title={APPLICATIONS_TILES.confirmedToday}
                    value={applications?.confirmedToday}
                    loading={isTransportLoading}
                />
            </StatGrid>
        </Panel>
    )
})
